// §V board data — the VARIANTS from the Claude Design canon `R10 - §V - canon F3`
// (project dd7b95d4, data-canon="R10-§V-F3"), transcribed verbatim: id/screen/source,
// N (stage count), family + carrierConfig (banner mechanism/name), nameMembers (banner
// subject), carrierStages (evidence line), the seven-layer slider matrix, and the cards[]
// (type, layers, cell/stub, dir). Each board is a `view` SectionV renders, exactly like
// §II/§III/§IV's boards.
//
// 14 boards: runs 01–08 (real datasets docs/design-datasets/runs/*.json) covering axis A
// (carrier layout) + degradations (scatter 06, empty 08), then synthetic v09–v12 for the
// axis-C connection types no run produces (group-vs-group, historical-singleton with a
// written cell, divergence, the remaining Section F stubs), then the two fit checks v13
// (longest pattern_name, N=12) and v14 (four longest descriptions).
//
// The corpus is single-axis (29 bios move only Security), so the axis-C card variants are
// carried by the Catalog CELL/STUB copy (in SectionV.jsx), NOT by live engine output —
// that is the corpus constraint (project_epic20_singleaxis), not a threshold to tune.
//
// `fit` is CD's real-browser fitSheet result, captured once: only v14 triggers it (both
// concession stages, no remainder). SSR renders the declared fit; the client re-fit is
// cosmetic — the §IV labelMode contract.

const ALL7 = ['Vitality', 'Security', 'Growth', 'Authorship', 'Wanting', 'Yourself', 'Lasting'];

const V = [
  // 01 · одиночка (ведущий расклад)
  {
    id: 'v01', screen: '§V · 01 · одиночка', source: '01-singleton.json', N: 5,
    family: 'singleton', carrierConfig: 'singleton', nameMembers: ['Yourself'], carrierStages: [2, 3, 4],
    layers: { Vitality: [1, 2, 1, 1, 1], Security: [1, 2, 1, 1, 1], Growth: [1, 2, 1, 1, 1], Authorship: [1, 2, 1, 1, 1], Wanting: [1, 2, 0, 0, 0], Yourself: [2, 2, -2, -2, -2], Lasting: [1, 2, 1, 1, 1] },
    cards: [
      { type: 'current-singleton', layers: ['Yourself'], dir: 'below', stage: 4, cell: 'A.2.6.1', stub: null },
      { type: 'triplet-as-one', layers: ['Vitality', 'Security', 'Growth', 'Authorship', 'Wanting', 'Lasting'], cell: 'A.3.1', stub: null },
      { type: 'historical-singleton', layers: ['Yourself'], dir: 'below', stages: [2, 3], cell: null, stub: 'F.3.spatial' },
    ],
  },
  // 02 · пара
  {
    id: 'v02', screen: '§V · 02 · пара', source: '02-together-pair.json', N: 4,
    family: 'together', carrierConfig: 'pair', nameMembers: ['Vitality', 'Security'], carrierStages: [0, 1, 2, 3],
    layers: { Vitality: [0, 1, 2, 3], Security: [0, 1, 2, 3] },
    cards: [{ type: 'parallel-whole', layers: ['Vitality', 'Security'], cell: 'A.1', stub: null }],
  },
  // 03 · тройка
  {
    id: 'v03', screen: '§V · 03 · тройка', source: '03-triplet.json', N: 4,
    family: 'together', carrierConfig: 'triplet', nameMembers: ['Vitality', 'Security', 'Growth'], carrierStages: [0, 1, 2, 3],
    layers: { Vitality: [0, 1, 2, 3], Security: [0, 1, 2, 3], Growth: [0, 1, 2, 3] },
    cards: [{ type: 'triplet-as-one', layers: ['Vitality', 'Security', 'Growth'], cell: 'A.3.1', stub: null }],
  },
  // 04 · поле
  {
    id: 'v04', screen: '§V · 04 · поле', source: '04-field-level.json', N: 5,
    family: 'field', carrierConfig: 'field', nameMembers: ALL7, carrierStages: [2, 4],
    layers: { Vitality: [1, 2, -2, 0, 2], Security: [1, 2, -2, 0, 2], Growth: [1, 2, -1, 0, 2], Authorship: [1, 2, -1, 1, 2], Wanting: [1, 2, -2, 0, 1], Yourself: [1, 2, -2, 0, 1], Lasting: [1, 2, -1, 1, 2] },
    cards: [
      { type: 'field-level-recovery', layers: ALL7, trough: 2, cell: 'A.4.2', stub: null },
      { type: 'triplet-as-one', layers: ALL7, cell: 'A.3.1', stub: null },
    ],
  },
  // 05 · раскол
  {
    id: 'v05', screen: '§V · 05 · раскол', source: '05-split-opposition.json', N: 5,
    family: 'opposition', carrierConfig: 'split', nameMembers: ['Yourself', 'Security'], carrierStages: [0, 3, 4],
    layers: { Vitality: [1, 2, 2, 0, -1], Security: [1, 2, 2, 2, 2], Growth: [1, 2, 2, 0, -1], Authorship: [1, 2, 2, 0, -1], Wanting: [1, 2, 2, -1, -2], Yourself: [2, 3, 2, -2, -3], Lasting: [1, 2, 2, 0, -1] },
    cards: [
      { type: 'parallel-whole', layers: ['Wanting', 'Yourself'], cell: 'A.1', stub: null },
      { type: 'current-singleton', layers: ['Security'], dir: 'above', stage: 4, cell: 'A.2.2.1', stub: null },
      { type: 'triplet-as-one', layers: ['Vitality', 'Growth', 'Authorship', 'Wanting', 'Lasting'], cell: 'A.3.1', stub: null },
    ],
  },
  // 06 · рассыпание
  {
    id: 'v06', screen: '§V · 06 · рассыпание (scatter)', source: '06-scatter.json', N: 5,
    family: 'scatter', carrierConfig: 'scatter', nameMembers: [], carrierStages: [],
    layers: { Vitality: [-1, 1, 1, -1, 1], Security: [0, -1, 0, -1, 0], Growth: [-1, 0, 1, 1, 1], Authorship: [1, 1, 1, -1, -1], Wanting: [1, -1, -1, 1, -1], Yourself: [-1, -1, -1, 1, 1], Lasting: [1, 1, -1, 0, -1] },
    cards: [{ type: 'scatter', layers: ALL7, cell: null, stub: 'F.7' }],
  },
  // 07 · длинный (краевой)
  {
    id: 'v07', screen: '§V · 07 · длинный · M = 3', source: '07-long.json', N: 5,
    family: 'singleton', carrierConfig: 'singleton', nameMembers: ['Lasting'], carrierStages: [3, 4],
    layers: { Vitality: [1, 1, 0, -1, -2], Security: [1, 1, 0, -1, -1], Growth: [1, 1, 0, -1, -2], Authorship: [1, 1, 1, 0, -1], Wanting: [1, 1, 1, 1, 0], Yourself: [1, 1, 0, -1, -2], Lasting: [2, 2, 2, 2, 2] },
    cards: [
      { type: 'current-singleton', layers: ['Lasting'], dir: 'above', stage: 4, cell: 'A.2.7.1', stub: null },
      { type: 'triplet-as-one', layers: ['Vitality', 'Security', 'Growth', 'Authorship', 'Yourself'], cell: 'A.3.1', stub: null },
      { type: 'parallel-whole', layers: ['Authorship', 'Wanting'], cell: 'A.1', stub: null },
    ],
  },
  // 08 · пустой ввод · раздел снят (правка F4: было triplet-as-one «moving as one» на плоских
  // кривых — ложь про пользователя; теперь §V вырождается до section_absent + перенумерация)
  {
    id: 'v08', screen: '§V · 08 · пустой ввод · раздел снят', source: '08-empty.json', N: 5,
    family: 'together', carrierConfig: 'field', nameMembers: ALL7, carrierStages: [0, 1, 2, 3, 4],
    layers: { Vitality: [1, 1, 1, 1, 1], Security: [1, 1, 1, 1, 1], Growth: [1, 1, 1, 1, 1], Authorship: [1, 1, 1, 1, 1], Wanting: [1, 1, 1, 1, 1], Yourself: [1, 1, 1, 1, 1], Lasting: [1, 1, 1, 1, 1] },
    cards: [], absent: true,
  },
  // ---- ось C · типы, не закрытые прогонами (синтетика на канонических ячейках) ----
  // 09 · group-vs-group
  {
    id: 'v09', screen: '§V · 09 · group-vs-group', source: 'synthetic', N: 5,
    family: 'opposition', carrierConfig: 'split', nameMembers: ['Growth', 'Yourself'], carrierStages: [0, 2, 4],
    layers: { Vitality: [2, 2, 2, 2, 2], Security: [2, 2, 2, 2, 2], Growth: [2, 2, 2, 2, 2], Lasting: [2, 2, 2, 2, 2], Authorship: [-2, -2, -2, -2, -2], Wanting: [-2, -2, -2, -2, -2], Yourself: [-2, -2, -2, -2, -2] },
    cards: [{ type: 'group-vs-group', layers: ['Vitality', 'Security', 'Growth', 'Lasting', 'Authorship', 'Wanting', 'Yourself'], dominantBlock: ['Vitality', 'Security', 'Growth', 'Lasting'], cell: 'A.3.2', stub: null }],
    synthetic: true,
  },
  // 10 · historical-singleton (написанная ячейка)
  {
    id: 'v10', screen: '§V · 10 · historical-singleton (написанная ячейка)', source: 'synthetic', N: 5,
    family: 'singleton', carrierConfig: 'singleton', nameMembers: ['Authorship'], carrierStages: [0, 1],
    layers: { Vitality: [0, 0, 0, 0, 0], Security: [0, 0, 0, 0, 0], Growth: [0, 0, 0, 0, 0], Authorship: [3, 3, 1, 0, 0], Wanting: [0, 0, 0, 0, 0], Yourself: [0, 0, 0, 0, 0], Lasting: [0, 0, 0, 0, 0] },
    cards: [{ type: 'historical-singleton', layers: ['Authorship'], dir: 'above', stages: [0, 1], cell: 'A.2.4.2', stub: null }],
    synthetic: true,
  },
  // 11 · divergence-over-time (дыра в каталоге → F.2)
  {
    id: 'v11', screen: '§V · 11 · divergence-over-time (дыра в каталоге → F.2)', source: 'synthetic', N: 5,
    family: 'opposition', carrierConfig: 'split', nameMembers: ['Growth', 'Wanting'], carrierStages: [0, 2, 4],
    layers: { Vitality: [1, 1, 1, 1, 1], Security: [1, 1, 1, 1, 0], Growth: [1, 2, 2, 3, 3], Authorship: [1, 1, 1, 0, 0], Wanting: [1, 1, 0, -2, -3], Yourself: [1, 1, 1, 0, 0], Lasting: [1, 1, 1, 1, 1] },
    cards: [{ type: 'divergence-over-time', layers: ['Growth', 'Wanting'], cell: null, stub: 'F.2' }],
    synthetic: true,
  },
  // 12 · остальные заглушки Section F
  {
    id: 'v12', screen: '§V · 12 · остальные заглушки Section F', source: 'synthetic', N: 5,
    family: 'together', carrierConfig: 'pair', nameMembers: ['Vitality', 'Lasting'], carrierStages: [0, 2, 4],
    layers: { Vitality: [1, 0, -2, 0, 1], Security: [1, 1, 1, 1, 1], Growth: [1, 1, 1, 1, 1], Authorship: [-1, 1, -1, 2, -1], Wanting: [1, 1, 1, 1, 1], Yourself: [1, 1, 1, 1, 1], Lasting: [1, 0, -2, 0, 1] },
    cards: [
      { type: 'parallel-whole', layers: ['Vitality', 'Lasting'], cell: null, stub: 'F.1' },
      { type: 'v-shape-recovery', layers: ['Authorship'], cell: null, stub: 'F.5.active-rebuild' },
      { type: 'singleton-cycling', layers: ['Authorship'], cell: null, stub: 'F.6' },
    ],
    synthetic: true,
  },
  // ---- fit-проверки ----
  // 13 · fit · тройка длинных имён · N = 12
  {
    id: 'v13', screen: '§V · 13 · fit · тройка длинных имён · N = 12', source: 'synthetic', N: 12,
    family: 'together', carrierConfig: 'triplet', nameMembers: ['Yourself', 'Lasting', 'Authorship'], carrierStages: [0, 3, 6, 9, 11],
    layers: { Yourself: [-2, -1, 0, 1, 1, 2, 2, 1, 0, 1, 2, 3], Lasting: [-2, -1, 0, 1, 1, 2, 2, 1, 0, 1, 2, 3], Authorship: [-2, -1, 0, 1, 1, 2, 2, 1, 0, 1, 2, 3] },
    cards: [{ type: 'triplet-as-one', layers: ['Yourself', 'Lasting', 'Authorship'], cell: 'A.3.1', stub: null }],
    synthetic: true,
  },
  // 14 · fit на пределе · M = 4 · оба режима уступок (real-browser fit baked)
  {
    id: 'v14', screen: '§V · 14 · fit · четыре длинных description', source: 'synthetic', N: 5,
    family: 'together', carrierConfig: 'triplet', nameMembers: ['Vitality', 'Security', 'Growth'], carrierStages: [0, 2, 4],
    layers: { Vitality: [2, 2, 2, 1, 2], Security: [2, 2, 2, 2, 2], Growth: [2, 2, 1, 2, 2], Lasting: [2, 2, 2, 1, 2], Authorship: [-2, -2, -1, -2, -2], Wanting: [-2, -1, -2, -2, -2], Yourself: [-2, -2, -2, -1, -2] },
    cards: [
      { type: 'group-vs-group', layers: ['Vitality', 'Security', 'Growth', 'Lasting', 'Authorship', 'Wanting', 'Yourself'], dominantBlock: ['Vitality', 'Security', 'Growth', 'Lasting'], cell: 'A.3.2', stub: null },
      { type: 'field-level-recovery', layers: ALL7, trough: 2, cell: 'A.4.2', stub: null },
      { type: 'parallel-whole', layers: ['Vitality', 'Security'], cell: 'A.1', stub: null },
      { type: 'current-singleton', layers: ['Security'], dir: 'above', stage: 4, cell: 'A.2.2.1', stub: null },
    ],
    synthetic: true,
    // CD real-browser fitSheet: both concession stages fire, no remainder.
    fit: { tight: true, smaller: true, miniH: '112px', note: 'плотный шаг · мини-чарт 130 → 112px · описание 14 → 13.2px' },
  },
  // ---- F4 · деградация на пустой/плоский ввод ----
  // 15 · граница триггера: один слой (security) сдвинулся на одно деление → сигнал есть,
  // раздел печатается как обычно (A.2.2.1 — ячейка написана, новой копи не нужно). Пара 08/15
  // задаёт границу: снимаем раздел только когда карточек ноль И спред всех слоёв нулевой.
  {
    id: 'v15', screen: '§V · 15 · граница триггера · сигнал есть', source: 'synthetic', N: 5,
    family: 'singleton', carrierConfig: 'singleton', nameMembers: ['Security'], carrierStages: [4],
    layers: { Vitality: [1, 1, 1, 1, 1], Security: [1, 1, 1, 1, 2], Growth: [1, 1, 1, 1, 1], Authorship: [1, 1, 1, 1, 1], Wanting: [1, 1, 1, 1, 1], Yourself: [1, 1, 1, 1, 1], Lasting: [1, 1, 1, 1, 1] },
    cards: [{ type: 'current-singleton', layers: ['Security'], dir: 'above', stage: 4, cell: 'A.2.2.1', stub: null }],
    synthetic: true,
  },
  // 16 · каскад: тот же пустой ввод снимает §V (нет сигнала) И §VI (< 2 цитат); сдвиг
  // применяется один раз к остатку — §VII → §V. `cascade` меняет только строки таблицы сдвига.
  {
    id: 'v16', screen: '§V · 16 · каскад · §V и §VI сняты', source: '08-empty.json', N: 5,
    family: 'together', carrierConfig: 'field', nameMembers: ALL7, carrierStages: [],
    layers: { Vitality: [1, 1, 1, 1, 1], Security: [1, 1, 1, 1, 1], Growth: [1, 1, 1, 1, 1], Authorship: [1, 1, 1, 1, 1], Wanting: [1, 1, 1, 1, 1], Yourself: [1, 1, 1, 1, 1], Lasting: [1, 1, 1, 1, 1] },
    cards: [], absent: true, cascade: true,
    synthetic: true,
  },
];

export const V_BOARDS = V;
export const V_PARITY_BOARDS = V_BOARDS.filter((b) => b.parity !== false);
